module.exports = __webpack_public_path__ + "static/media/promo.b8dbf2ca.png";